export default __webpack_public_path__ + "static/media/priorityAreasOfFocusEditMode.150f1f88.png";